module.exports = __webpack_public_path__ + "media/images/emblems/CHE_Luesslingen-Nennigkofen_COA-6fbdd427026b9938654bc98f6fdbd7a7.svg";